import { Flex, Text } from '@auviknetworks/iceberg-ui';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SuccessBox } from './internal/SuccessBox';

export const DeployAgentCompletedStep = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Flex
            alignItems="center"
            data-testid="onboardingDeployAgentCompletedStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={['32px', '32px', '32px', 5]}
                color={theme.palette.onboarding.titleTextColor}
                fontWeight="600"
                textAlign="center"
            >
                {t('Onboarding.deployAgentSuccess.title')}
            </Text>
            <Text
                fontSize={4}
                color={theme.palette.onboarding.titleTextColor}
                mt={4}
                textAlign="center"
            >
                {t('Onboarding.deployAgentSuccess.subtitle')}
            </Text>
            <SuccessBox />
        </Flex>
    );
};
